import type { VoidFunctionComponent } from 'react';

import { CheckboxMenuItem } from '../../../generic';
import Tooltip from '../../../generic/Tooltip';
import { TEAM_NAME_LENGTH_LIMIT } from './common';
import styles from './TeamSelectionMenu.module.less';

type Props = {
  name: string;
  count?: number;
  isSelected: boolean;
  onClick: () => void;
};

/**
 * A single, selectable team item.
 */
const TeamMenuItem: VoidFunctionComponent<Props> = ({
  name,
  count,
  isSelected,
  onClick,
}) => {
  const shouldTruncateAndTooltip = name.length > TEAM_NAME_LENGTH_LIMIT;
  const processedName = shouldTruncateAndTooltip
    ? `${name.substring(0, TEAM_NAME_LENGTH_LIMIT)}...`
    : name;

  const contents = (
    <CheckboxMenuItem
      className={styles.item}
      onClick={(e) => {
        // This is the recommended way to handle keepOpen:
        // https://szhsin.github.io/react-menu/#event-handling
        // eslint-disable-next-line no-param-reassign
        e.keepOpen = true;
        onClick();
      }}
      count={count}
      checked={isSelected}
      >
      <span className={styles.itemName}>{processedName}</span>
    </CheckboxMenuItem>
  );

  return shouldTruncateAndTooltip ? (
    <Tooltip id={`team-selection-menu-item-${name}`} tooltip={name}>
      <span>{contents}</span>
    </Tooltip>
  ) : (
    contents
  );
};

export default TeamMenuItem;
